const KEY = "nc_county_pref";

export function getCountyPref() {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); }
  catch { return null; }
}

export function setCountyPref(pref) {
  localStorage.setItem(KEY, JSON.stringify(pref));
  window.dispatchEvent(new Event("nc-county-pref-changed"));
}
